export default {
  key: 'system--preview',
  // Two URL shapes both serve the preview:
  //   - production wildcard host `<owner>--<key>.preview.symbols.app/`
  //     lands on the bare `/` route — no path prefix.
  //   - workspace-shell mount + bootShell `fallbackRoute: '/preview'`
  //     rewrites the URL to `/preview` so the shell's mount-routing
  //     picks this manifest up.
  // Matching both shapes here prevents bootShell from rewriting `/`
  // to `/preview` on the production wildcard — that rewrite stripped
  // the inbound `?owner=…&key=…` query and showed an empty viewport.
  routes: [/^\/$/, /^\/preview(\/|$)/],
  i18nNamespaces: ['preview'],
  app:     () => import('./app.js').then(m => m.default),
  context: () => import('./context.js').then(m => m.default),
}
